var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9195 15.8C19.7295 15.8 19.5395 15.73 19.3895 15.58L12.8695 9.05999C12.3895 8.57999 11.6095 8.57999 11.1295 9.05999L4.60953 15.58C4.31953 15.87 3.83953 15.87 3.54953 15.58C3.25953 15.29 3.25953 14.81 3.54953 14.52L10.0695 7.99999C11.1295 6.93999 12.8595 6.93999 13.9295 7.99999L20.4495 14.52C20.7395 14.81 20.7395 15.29 20.4495 15.58C20.2995 15.72 20.1095 15.8 19.9195 15.8Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.886163acbe99cb6e486ed6be0c6ec37d.svg";
export { ForwardRef as ReactComponent };